module.exports = __webpack_public_path__ + "static/media/alert_selected.cd8483e0.svg";